//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/ScCollector.js";
let d=[[[0,"NumberOfColors",1,0],[1,"PrimaryFaces",0,"ScCollector",0],[0,"RadiusDisplay",1,0],[0,"RadiusMaxValue",1,0],[0,"RadiusMinValue",1,0],[1,"SecondaryFaces",0,"ScCollector",0],[1,"SelectBody",0,"ScCollector",0],[0,"SlopeDataRange",1,0],[0,"UndercutsDisplay",1,0]],[[["origin"],"SetCsysOrigin",{},1,0],[["matrix"],"SetCsysMatrix",{},1,0],[["faceTag","point","isPrimaryFace"],"SetSelectedFace",{},3,0],[[],"UpdateBoundingBoxData",{},0,0],[[],"CalculateOrientation",{},0,0],[["regionType","cancelDisplay"],"CheckRegions",{},2,0],[["updateItem"],"UpdateSlopeDisplay",{},1,0],[[],"RemoveAllFaces",{},0,0],[[],"CycleConeDirection",{},0,0],[[],"DeleteAuxiliaryObjects",{},0,0],[["bodyTag"],"SetOriginalProduct",{},1,0],[["face","location"],"CreatePMILabel",{},2,0],[["face","location"],"CreateRadiusPMILabel",{},2,0],[["updateItem"],"UpdateRadiusDisplay",{},1,0]],[]];
SPLM.Tooling.MoldDirectionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.MoldDirectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.MoldDirectionBuilder.OrientView = Object.freeze({
    "None" : "None", "Top" : "Top", "Front" : "Front", "Right" : "Right", "Back" : "Back", "Bottom" : "Bottom", "Left" : "Left", "Trimetric" : "Trimetric", "Isometric" : "Isometric"});

SPLM.Tooling.MoldDirectionBuilder.RegionType = Object.freeze({
    "Region" : "Region", "Undercut" : "Undercut"});

SPLM.Tooling.MoldDirectionBuilder.SlopeUpdateItem = Object.freeze({
    "All" : "All", "Selection" : "Selection", "Direction" : "Direction", "SlopeDataRange" : "SlopeDataRange", "RemoveResult" : "RemoveResult", "RemovePMILabel" : "RemovePMILabel"});

SPLM.Tooling.MoldDirectionBuilder.RadiusUpdateItem = Object.freeze({
    "All" : "All", "NumOfColors" : "NumOfColors", "MinValue" : "MinValue", "MaxValue" : "MaxValue", "RemoveResult" : "RemoveResult", "RemovePMILabel" : "RemovePMILabel"});

export default SPLM;